<template>
  <div>
    <va-card class="import-card">
      <h5>{{ $t('menu.import_loads') }}</h5>
      <va-progress-bar :indeterminate="loading" color="greenLight" />
        <div class="va-row row wrap">
          <div class="flex xs3">
            <form ref="form" @submit.prevent>
              <va-file-upload dropzone single v-model="file" />
              <va-button color="greenLight" icon="iconicstroke iconicstroke-info" @click="submitFile()">
                {{ $t('menu.save')}}
              </va-button>
              <BackButton />
            </form>
          </div>

          <div class="flex xs2" align="center">
            <va-card>
              <strong>Modelo de Arquivo .csv</strong>
              <a href="loads_upload.csv" download>
                <img src="csv.png"/>
              </a>
            </va-card>
          </div>

          <div class="flex xs2" align="center">
            <va-card >
              <strong>Modelo de Arquivo .xlsx</strong>
              <a href="loads_upload.xlsx" download>
                <img src="excel.png" />
              </a>
            </va-card>
          </div>
        </div>
    </va-card>
  </div>
  
</template>

<script>
import { showError } from '@/global'
import { http } from '@/services/config'
import BackButton from '../shared/BackButton'

export default {
  components: { BackButton },
  data() {
    return {
      file: [],
      loading: false,
    }
  },

  methods: {
    reset() {
      this.$refs.form.reset()
    },

    submitFile() {
      this.loading = true

      let formData = new FormData()
      formData.append('file', this.file[0])

      http.post('import_file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(() => {
        this.$toasted.global.defaultSuccess({ msg: "Import concluído com sucesso!"})
        this.loading = false
      }).catch(e => {
        this.loading = false
        showError(e)
      })
    },
  },
}
</script>

<style scoped>
.import-card {
  min-height: 300px;
  max-height: 400px;
}

.import-card h5 {
  margin-bottom: 50px;
}

form {
  padding-top: 25px;
}

img, svg {
  height: 100px;
}
</style>
